import * as React from 'react'

import createForm from './createForm'
import type {FormType, FormAtPathType} from './createForm'
import FieldController from './FieldController'
import {FORM_ROOT_FIELD_PATH} from './flags'
import type {
  FormPropsType,
  FormDefinitionType,
  FormDefinitionMethodsType,
  FormDataType,
} from './Form'
import {defaultSerializer} from './util'

export type FormControllerCreationPropsType = FormPropsType &
  FormDefinitionType &
  FormDefinitionMethodsType
// eslint-disable-next-line react/no-unsafe
export default class ControlledForm extends React.PureComponent<FormControllerCreationPropsType> {
  form?: FormType
  dispose?: () => void
  setData?: (newData: FormDataType) => void
  setConfig?: (config: any) => void
  rootFieldProps?: FormAtPathType

  constructor(props: FormControllerCreationPropsType) {
    super(props)
    const {children} = props
    if (typeof children !== 'function') {
      throw new Error(
        'You must place a function as a single and direct child of <Form>'
      )
    }
  }

  UNSAFE_componentWillMount() {
    const {
      props: {
        data = {},
        withNestedFields,
        validateWhenDataPreloaded,
        scrollToInvalidField,
      },
    } = this
    const dispatch = (action) => this.props.dispatch(action)
    const onSubmit = (serializedValues, form, options) =>
      this.props.onSubmit
        ? this.props.onSubmit(serializedValues, form, options)
        : undefined
    const serializer = (dataState) =>
      this.props.serializer
        ? this.props.serializer(dataState)
        : defaultSerializer(dataState)
    const {form, dispose, setData, setConfig} = createForm({
      data,
      dispatch,
      onSubmit,
      serializer,
      validateWhenDataPreloaded,
      scrollToInvalidField,
      withNestedFields,
    })
    this.form = form
    this.dispose = dispose
    this.setData = setData
    this.setConfig = setConfig
    this.rootFieldProps = form.getField(FORM_ROOT_FIELD_PATH)
    if (DEBUG) {
      form.changeStream.subscribe(({data: d, changeCount}) => {
        // eslint-disable-next-line no-console
        console.debug(`FORM STATE CHANGE (${changeCount})`)
        // eslint-disable-next-line no-console
        console.table(d)
      })
    }
  }

  UNSAFE_componentWillReceiveProps(newProps: FormControllerCreationPropsType) {
    const {children, data = {}, validateWhenDataPreloaded} = newProps
    if (typeof children !== 'function') {
      throw new Error(
        'You must place a function as a single and direct child of <Form>'
      )
    }
    this.setData!(data)
    this.setConfig!(validateWhenDataPreloaded)
  }

  componentWillUnmount() {
    this.dispose!()
  }

  render() {
    const {rootFieldProps} = this
    const {children, disabled, firstValidationAfterSubmit, submitFeedback} =
      this.props
    return (
      <FieldController
        {...rootFieldProps}
        disabled={disabled}
        firstValidationAfterSubmit={firstValidationAfterSubmit}
        submitFeedback={submitFeedback}
      >
        {children}
      </FieldController>
    )
  }
}
